import type { AuditResults, SiteAudit } from '../../types/audit';

const DATA_URL = '/data/audit-results.json';

let cachedData: AuditResults | null = null;

export async function loadAuditData(): Promise<AuditResults> {
  if (cachedData) {
    return cachedData;
  }

  try {
    const response = await fetch(DATA_URL);

    if (!response.ok) {
      throw new Error(`Failed to load audit data: ${response.status}`);
    }

    const data = await response.json();
    cachedData = data as AuditResults;
    return cachedData;
  } catch (error) {
    console.error('Error loading audit data:', error);
    throw error;
  }
}

export async function getSiteById(siteId: string): Promise<SiteAudit | undefined> {
  const data = await loadAuditData();
  return data.sites.find((site) => site.id === siteId);
}

export function clearCache(): void {
  cachedData = null;
}
